import { TUNING_MODE_AEOLIAN, TUNING_MODE_DORIAN, TUNING_MODE_IONIAN, TUNING_MODE_LOCRIAN, TUNING_MODE_LYDIAN, TUNING_MODE_MIXOLYDIAN, TUNING_MODE_PHRYGIAN } from "./chords"

export const EMOJI_NEUTRAL = "😐"
export const EMOJI_NEUTRAL_EYES_CLOSED = "😑"
export const EMOJI_LEFT_WINK = "😉"
export const EMOJI_DIAGONAL_MOUTH = "🫤"
export const EMOJI_EYES_ROLLING_UP = "🙄"
export const EMOJI_SMILING_SLIGHTLY = "🙂"
export const EMOJI_SMILING_EYES_CLOSED = "😊"
export const EMOJI_SMILING_GRIN = "😀"
export const EMOJI_SMILING_BIG_GRIN = "😃"
export const EMOJI_SMILING_GRIN_SQUINT = "😆"
export const EMOJI_SMILING_BIG_TEETH_GRIN = "😁"
export const EMOJI_OPEN_MOUTH = "😯"
export const EMOJI_OPEN_MOUTH_BIG = "😮"
export const EMOJI_WAIL = "😩"
export const EMOJI_ASTONISHED = "😲"
export const EMOJI_GRIMACING = "😬"
export const EMOJI_ZANY = "🤪"
export const EMOJI_KISS = "😗"
export const EMOJI_KISS_EYES_CLOSED = "😙"
export const EMOJI_KISSING_WINK = "😘"
export const EMOJI_SMIRK = "😏"
export const EMOJI_UNAMUSED = "😒"
export const EMOJI_RAISED_EYEBROW = "🤨"
export const EMOJI_CONFUSED = "😕"
export const EMOJI_ANNOYED = "😖"
export const EMOJI_WORRIED = "😟"
export const EMOJI_FROWNING = "☹️"
export const EMOJI_FROWN_EYES_CLOSED_RAISED_EYEBROWS = "😔"
export const EMOJI_FROWN_EYES_CLOSED = "😞"
export const EMOJI_ANGRY = "😠"
export const EMOJI_TRIPPY = "😵‍💫"
export const EMOJI_SHAKING = "🫨"
export const EMOJI_SHAKING_HORIZONTALLY = "🙂‍↔️"
export const EMOJI_SHAKING_VERTICALLY = "🙂‍↕️"

export const EMOJI_CRYING = "😭"

export const EMOJI_HEARTS = "🥰"
export const EMOJI_HEART_EYES = "😍"
export const EMOJI_STAR_STRUCK = "🤩"
export const EMOJI_PARTY = "🥳"
export const EMOJI_UPSIDE_DOWN = "🙃"
export const EMOJI_HAPPY_TEARS = "🥲"
export const EMOJI_HOLDING_TEARS = "🥹"
export const EMOJI_SAVORING = "😋"
export const EMOJI_TONGUE = "😛"
export const EMOJI_TONGUE_WINK = "😜"
export const EMOJI_TONGUE_SQUINT = "😝"
export const EMOJI_HALO = "😇"
export const EMOJI_SALUTE = "🫡"
export const EMOJI_THINKING = "🤔"
export const EMOJI_SHUSHING = "🤫"
export const EMOJI_HAND_OVER_MOUTH = "🫢"
export const EMOJI_GIGGLING = "🤭"
export const EMOJI_YAWNING = "🥱"
export const EMOJI_HUGGING = "🤗"
export const EMOJI_PEEKING = "🫣"
export const EMOJI_SCREAMING = "😱"
export const EMOJI_MONOCLE = "🧐"
export const EMOJI_EXHALING = "😮‍💨"
export const EMOJI_STEAM = "😤"
export const EMOJI_RAGE = "🤬"
export const EMOJI_PLEADING = "🥺"
export const EMOJI_ANXIOUS = "😰"
export const EMOJI_FEARFUL = "😨"
export const EMOJI_ANGUISHED = "😧"
export const EMOJI_SHOCKED = "😲"
export const EMOJI_FLUSHED = "😳"
export const EMOJI_MIND_BLOWN = "🤯"
export const EMOJI_DOWNCAST_SWEAT = "😓"
export const EMOJI_PERSEVERING = "😣"
export const EMOJI_TIRED = "😫"
export const EMOJI_DIZZY = "😵"
export const EMOJI_DOTTED_LINE = "🫥"
export const EMOJI_SLEEPING = "😴"
export const EMOJI_SLEEPY = "😪"
export const EMOJI_DROOLING = "🤤"
export const EMOJI_MOON_FACE = "🌛"
export const EMOJI_MOON_FACE_LEFT = "🌜"
export const EMOJI_NEW_MOON_FACE = "🌚"
export const EMOJI_FULL_MOON_FACE = "🌝"
export const EMOJI_SUN_FACE = "🌞"
export const EMOJI_MELTING = "🫠"
export const EMOJI_FOG = "😶‍🌫︎"
export const EMOJI_WOOZY = "🥴"
export const EMOJI_HOT = "🥵"
export const EMOJI_COLD = "🥶"
export const EMOJI_NAUSEATED = "🤢"
export const EMOJI_VOMITING = "🤮"
export const EMOJI_SNEEZING = "🤧"
export const EMOJI_SICK = "🤒"
export const EMOJI_INJURED = "🤕"
export const EMOJI_MASK = "😷"
export const EMOJI_COWBOY = "🤠"
export const EMOJI_MONEY = "🤑"
export const EMOJI_SUNGLASSES = "😎"
export const EMOJI_NERD = "🤓"
export const EMOJI_DISGUISED = "🥸"
export const EMOJI_LYING = "🤥"
export const EMOJI_CLOWN = "🤡"
export const EMOJI_GHOST = "👻"
export const EMOJI_POOP = "💩"
export const EMOJI_ALIEN = "👽"
export const EMOJI_ROBOT = "🤖"
export const EMOJI_SLEEPING_SYMBOL = "💤"
export const EMOJI_HOLE = "🕳︎"
export const EMOJI_PARTY_POPPER = "🎉"
export const EMOJI_CONFETTI = "🎊"
export const EMOJI_SEE_NO_EVIL = "🙈"
export const EMOJI_HEAR_NO_EVIL = "🙉"
export const EMOJI_SPEAK_NO_EVIL = "🙊"
export const EMOJI_CAT_GRINNING = "😺"
export const EMOJI_CAT_HAPPY = "😸"
export const EMOJI_CAT_TEARS_JOY = "😹"
export const EMOJI_CAT_HEART_EYES = "😻"
export const EMOJI_CAT_SMIRK = "😼"
export const EMOJI_CAT_KISSING = "😽"
export const EMOJI_CAT_SCREAMING = "🙀"
export const EMOJI_CAT_CRYING = "😿"
export const EMOJI_CAT_POUTING = "😾"
export const EMOJI_HEART_RED = "❤︎"
export const EMOJI_HEART_ORANGE = "🧡"
export const EMOJI_HEART_YELLOW = "💛"
export const EMOJI_HEART_GREEN = "💚"
export const EMOJI_HEART_BLUE = "💙"
export const EMOJI_HEART_PURPLE = "💜"
export const EMOJI_HEART_BROWN = "🤎"
export const EMOJI_HEART_BLACK = "🖤"
export const EMOJI_HEART_WHITE = "🤍"
export const EMOJI_HEART_CLASSIC = "♥︎"

export const EMOJI_SEQUENCE = [
    // Happiest
    EMOJI_STAR_STRUCK,
    EMOJI_HEARTS,
    EMOJI_HEART_EYES,
    EMOJI_PARTY,
    EMOJI_SMILING_BIG_TEETH_GRIN,
    EMOJI_SMILING_BIG_GRIN,
    EMOJI_SMILING_GRIN_SQUINT,
    EMOJI_SMILING_GRIN,
    EMOJI_SMILING_EYES_CLOSED,
    EMOJI_SMILING_SLIGHTLY,
    EMOJI_NEUTRAL,
    EMOJI_NEUTRAL_EYES_CLOSED,
    EMOJI_CONFUSED,
    EMOJI_WORRIED,
    EMOJI_FROWNING,
    EMOJI_ANNOYED,
    EMOJI_FROWN_EYES_CLOSED_RAISED_EYEBROWS,
    EMOJI_FROWN_EYES_CLOSED,
    EMOJI_PERSEVERING,
    EMOJI_TIRED,
    EMOJI_WAIL,
    EMOJI_CRYING,
    // Unhappiest
]

// Major Emojis

export const TUNING_MODE_EMOJIS_MAJOR = [
    EMOJI_NEUTRAL,			        // Same as major
    EMOJI_HOLDING_TEARS,			// Start from second degree of major
    EMOJI_SMIRK,	            	// Start from third degree of major
    EMOJI_KISS_EYES_CLOSED,			// Start from fourth degree of major
    EMOJI_SMILING_EYES_CLOSED,		// Start from fifth degree of major
    EMOJI_SHOCKED,			        // Start from sixth degree (same as natural minor)
    EMOJI_TONGUE			        // Start from seventh degree
]

export const TUNING_MODE_EMOJIS_DICTIONARY_MAJOR = {
    [TUNING_MODE_IONIAN]:TUNING_MODE_EMOJIS_MAJOR[0],			// Same as major
    [TUNING_MODE_DORIAN]:TUNING_MODE_EMOJIS_MAJOR[1],			// Start from second degree of major
    [TUNING_MODE_PHRYGIAN]:TUNING_MODE_EMOJIS_MAJOR[2],		    // Start from third degree of major
    [TUNING_MODE_LYDIAN]:TUNING_MODE_EMOJIS_MAJOR[3],			// Start from fourth degree of major
    [TUNING_MODE_MIXOLYDIAN]:TUNING_MODE_EMOJIS_MAJOR[4],		// Start from fifth degree of major
    [TUNING_MODE_AEOLIAN]:TUNING_MODE_EMOJIS_MAJOR[5],			// Start from sixth degree (same as natural minor)
    [TUNING_MODE_LOCRIAN]:TUNING_MODE_EMOJIS_MAJOR[6]			// Start from seventh degree
}

// MINOR Emojis

export const TUNING_MODE_EMOJIS_MINOR = [
    EMOJI_NEUTRAL,			        // Same as minor
    EMOJI_PLEADING,			        // Start from second degree of minor
    EMOJI_CONFUSED,	            	// Start from third degree of minor
    EMOJI_FLUSHED,			        // Start from fourth degree of minor
    EMOJI_ANNOYED,		            // Start from fifth degree of minor
    EMOJI_SCREAMING,			    // Start from sixth degree (same as natural minor)
    EMOJI_GRIMACING			        // Start from seventh degree
]

export const TUNING_MODE_EMOJIS_DICTIONARY_MINOR = {
    [TUNING_MODE_IONIAN]:TUNING_MODE_EMOJIS_MINOR[0],			// Same as major
    [TUNING_MODE_DORIAN]:TUNING_MODE_EMOJIS_MINOR[1],			// Start from second degree of major
    [TUNING_MODE_PHRYGIAN]:TUNING_MODE_EMOJIS_MINOR[2],		    // Start from third degree of major
    [TUNING_MODE_LYDIAN]:TUNING_MODE_EMOJIS_MINOR[3],			// Start from fourth degree of major
    [TUNING_MODE_MIXOLYDIAN]:TUNING_MODE_EMOJIS_MINOR[4],		// Start from fifth degree of major
    [TUNING_MODE_AEOLIAN]:TUNING_MODE_EMOJIS_MINOR[5],			// Start from sixth degree (same as natural minor)
    [TUNING_MODE_LOCRIAN]:TUNING_MODE_EMOJIS_MINOR[6]			// Start from seventh degree
}

/**
 * Find the emoji for the specified scale and mode
 * @param {Number|String} scale 
 * @param {Number} mode 
 * @returns String Emoji
 */
export const getEmojiForScaleAndMode = (scale,mode) => {
    switch(scale){
        case "Minor":
        case 1:
            return TUNING_MODE_EMOJIS_MINOR[mode%TUNING_MODE_EMOJIS_MINOR.length]
        
        case "Major":
        case 0:
        default:
            return TUNING_MODE_EMOJIS_MAJOR[mode%TUNING_MODE_EMOJIS_MAJOR.length]
    }
}